import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component, Fragment } from 'react';
import '../../css/immocom.css';
import { DataNews } from '../../data/DataNews';
import { IDS_TYPE_MANDAT } from '../../data/DataTypeMandat';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
**************************************************************************************************
 PROPS:
    ATTRIBUTS :
        object  news                    news à afficher
        bool    isOpen                  détermine si fiche ouverte ou non
    METHODES :
        void    onDismiss()             méthode appelée à la fermeture du panel
        void    onEnregistrement()      méthode appelée lorsque le bouton "Enregistrer" est cliqué
**************************************************************************************************
*/

const objetState = {
    newsId: 0,
    newsTitre: "",
    newsContenu: "",
    newsIdsTypeMandat: [],
    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheNews extends Component {

    constructor(props) {
        super(props);
        this.state = objetState;
    };

    _creationContent = () => {

        const headerText = this.state.newsId === 0 ? "Publication d'une news" : "Modification de la news #" + (this.state.newsId);

        return <Fragment>
            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={headerText}
                isOpen={this.props.isOpen}
                onDismiss={this.props.onDismiss}
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.extraLarge}
            >
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <div className="d-flex flex-column">
                    {
                        [
                            { label: "Commercialisateurs", iconName: "Suitcase", idTypeMandat: IDS_TYPE_MANDAT.COMMERCIALISATEUR },
                            { label: "Gestionnaires de mandats", iconName: "TextDocument", idTypeMandat: IDS_TYPE_MANDAT.GESTIONNAIRE_MANDAT },
                            { label: "Opérationnels", iconName: "Settings", idTypeMandat: IDS_TYPE_MANDAT.OPERATIONNEL },
                            { label: "Direction commerciale", iconName: "WorkforceManagement", idTypeMandat: IDS_TYPE_MANDAT.DIRECTEUR_COMMERCIAL }
                        ]
                            .map((element, index) => <Toggle
                                checked={this.state.newsIdsTypeMandat.includes(element.idTypeMandat)}
                                inlineLabel
                                key={index}
                                label={
                                    <div className="d-flex align-items-center">
                                        <Icon iconName={element.iconName} />
                                        <span className="pl-1 pr-3">{element.label}</span>
                                    </div>
                                }
                                onChange={(event, checked) => this._onChangeToggle(checked, element.idTypeMandat)}
                            />
                            )
                    }
                </div>

                <EUITextField
                    label="Titre"
                    maxLength={MaxLengths.news.titre}
                    onDelayedChange={(event, newValue) => this.setState({ newsTitre: newValue }, this._onVerificationFormulaire)}
                    required
                    value={this.state.newsTitre}
                />

                <EUITextField
                    label="Message"
                    maxLength={MaxLengths.news.contenu}
                    multiline
                    onDelayedChange={(event, newValue) => this.setState({ newsContenu: newValue }, this._onVerificationFormulaire)}
                    required
                    rows={10}
                    value={this.state.newsContenu}
                />

            </Panel>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

        </Fragment>
    };

    _onChangeToggle = (checked, idTypeMandat) => {
        let newsIdsTypeMandat = [...this.state.newsIdsTypeMandat];
        if (checked)
            newsIdsTypeMandat.push(idTypeMandat);
        else
            newsIdsTypeMandat = newsIdsTypeMandat.filter((value) => value !== idTypeMandat);
        this.setState({ newsIdsTypeMandat: newsIdsTypeMandat }, this._onVerificationFormulaire);
    };

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de la news en cours'
        });

        const news = {
            idNews: this.state.newsId,
            titre: this.state.newsTitre,
            contenu: this.state.newsContenu,
            idsTypeMandat: this.state.newsIdsTypeMandat
        };

        var enregistrementNews = DataNews._onEnregistrementNews(news);

        enregistrementNews
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    this.props.onEnregistrement();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    };

    _onOpen = () => {
        if (this.props.news) { // Modification d'une news
            this.setState({
                newsId: this.props.news.idNews,
                newsTitre: this.props.news.titre,
                newsContenu: this.props.news.contenu,
                newsIdsTypeMandat: this.props.news.idsTypeMandat
            }, this._onVerificationFormulaire);
        } else { // Publication d'une nouvelle news
            this.setState(objetState);
        }
    };

    _onRenderFooterContent = () => {
        return <Fragment>
            <PrimaryButton onClick={this._onEnregistrement} disabled={!this.state.onActiveBoutonEnregistrer} className="marginRight8px">Enregistrer</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Annuler</DefaultButton>
        </Fragment>
    };

    _onVerificationFormulaire() {
        const news = {
            idNews: this.state.newsId,
            titre: this.state.newsTitre,
            contenu: this.state.newsContenu
        };

        Immocom.fiche()._validationFormulaire(this, 'News', news, (this.state.newsId > 0 ? 'Modification' : 'Création'));
    }

    render = () => {
        return this._creationContent();
    };
}